import _CircularProgress from "@mui/material/CircularProgress";
import _Typography from "@mui/material/Typography";
import _Divider from "@mui/material/Divider";
import _Box from "@mui/material/Box";
import _TextField from "@mui/material/TextField";
import _InputAdornment from "@mui/material/InputAdornment";
import _Tooltip from "@mui/material/Tooltip";
import _IconButton from "@mui/material/IconButton";
import _Button2 from "@mui/material/Button";
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import emptyStateIllustration from '../../../assets/images/find-illus.svg';
import { useCancellablePromise } from '../../../hooks';
import { EventService } from '../../../services';
import { SearchIcon } from '../../icons';
import FakeEmployees from './fake-employees';
import LeaderboardIndividualHeader from './header';
import LeaderboardIndividualItem from './item';
import RankCard from './rank-card';
function IndividualLeaderboard({
  FakeItemsCard,
  Button: _Button,
  enableHeader,
  event,
  currentUser,
  isMember,
  search,
  freeOfferEmployeesLeaderboardsMaxRowsCount,
  isFree,
  disableLeaderboardRestriction,
  setSearch
}) {
  const [initialized, setInitialized] = useState(false);
  const [tmpSearch, setTmpSearch] = useState(search);
  const [page, setPage] = useState(1);
  const [leaderboard, setLeaderboard] = useState();
  const [count, setCount] = useState();
  const [loading, setLoading] = useState(false);
  const [userItem, setUserItem] = useState();
  const {
    t
  } = useTranslation();
  const {
    cancellablePromise,
    cancelPromises
  } = useCancellablePromise();
  const {
    cancellablePromise: cancellableUserItemPromise,
    cancelPromises: cancelUserItemPromise
  } = useCancellablePromise();
  useEffect(() => {
    if (initialized) {
      if (isMember === false) setUserItem(null);else if (currentUser) getUserItem();else if (currentUser === null) setUserItem(null);
    }
    setInitialized(true);
    return () => {
      cancelUserItemPromise();
      setUserItem(undefined);
    };
  }, [initialized, currentUser, isMember]);
  useEffect(() => {
    if (initialized) {
      if (isMember === false) {
        setCount(0);
        setLeaderboard([]);
      } else {
        if (page > 1) setPage(1);
        getLeaderboard(1);
      }
    }
    return () => {
      cancelPromises();
      setLeaderboard(undefined);
    };
  }, [initialized, search, isMember]);
  useEffect(() => {
    if (page > 1 && isMember !== false) getLeaderboard(page);
  }, [page]);
  async function getUserItem() {
    try {
      const {
        items: [userItem]
      } = await cancellableUserItemPromise(EventService.getIndividualRanking(event.id, {
        page: 1,
        pageSize: 1,
        getConnectedUserRank: true
      }));
      setUserItem(userItem || null);
    } catch (err) {
      if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        console.error(err);
      }
    }
  }
  async function getLeaderboard(page) {
    setLoading(true);
    try {
      const {
        count,
        items
      } = await cancellablePromise(EventService.getIndividualRanking(event.id, {
        page,
        pageSize: isFree && !disableLeaderboardRestriction ? freeOfferEmployeesLeaderboardsMaxRowsCount : 10,
        search
      }));
      setCount(count);
      if (page === 1) setLeaderboard(items);else setLeaderboard([...(leaderboard || []), ...items]);
    } catch (err) {
      if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        console.error(err);
      }
    }
    setLoading(false);
  }
  const Button = _Button || _Button2;
  return /*#__PURE__*/React.createElement(_Box, {
    bgcolor: "#fff",
    borderRadius: 4,
    display: "flex",
    flexDirection: "column",
    gap: 3,
    padding: 3,
    sx: {
      containerType: 'inline-size'
    },
    width: "100%"
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 1,
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: {
      '@': 'column',
      '@500': 'row'
    },
    flexGrow: 1,
    gap: 1
  }, /*#__PURE__*/React.createElement(_TextField, {
    fullWidth: true,
    margin: "none",
    onChange: ({
      currentTarget: {
        value
      }
    }) => setTmpSearch(value),
    onKeyDown: ({
      key
    }) => {
      if (key === 'Enter') setSearch(tmpSearch);
    },
    placeholder: t('commons.challenges.leaderboard.search_cyclist'),
    size: "small",
    slotProps: {
      input: {
        endAdornment: tmpSearch && /*#__PURE__*/React.createElement(_InputAdornment, {
          position: "end"
        }, /*#__PURE__*/React.createElement(_Tooltip, {
          title: "Rechercher"
        }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_IconButton, {
          disabled: !tmpSearch,
          onClick: () => setSearch(tmpSearch),
          size: "small"
        }, /*#__PURE__*/React.createElement(SearchIcon, {
          fontSize: "small"
        })))))
      }
    },
    sx: {
      '.MuiInputBase-root': {
        bgcolor: '#fff'
      }
    },
    type: "text",
    value: tmpSearch,
    variant: "outlined"
  }))), /*#__PURE__*/React.createElement(RankCard, {
    challengeTemplate: event.challengeTemplate,
    numberOfParticipants: count,
    progress: userItem
  }), !leaderboard || leaderboard.length > 0 ? /*#__PURE__*/React.createElement(_Box, {
    border: "1px solid #dde0e7",
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    width: "100%"
  }, enableHeader && /*#__PURE__*/React.createElement(LeaderboardIndividualHeader, {
    event: event
  }), leaderboard ? /*#__PURE__*/React.createElement(React.Fragment, null, leaderboard.map((item, index) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: item.user.id
  }, /*#__PURE__*/React.createElement(_Divider, {
    sx: {
      borderColor: '#dde0e7'
    }
  }), /*#__PURE__*/React.createElement(LeaderboardIndividualItem, {
    challengeType: event.challengeTemplate?.type,
    item: item,
    prevItemRank: index > 0 ? leaderboard[index - 1].rank : null
  }))), isFree && !disableLeaderboardRestriction && count && count > freeOfferEmployeesLeaderboardsMaxRowsCount && /*#__PURE__*/React.createElement(FakeEmployees, {
    event: event,
    FakeItemsCard: FakeItemsCard,
    freeOfferEmployeesLeaderboardsMaxRowsCount: freeOfferEmployeesLeaderboardsMaxRowsCount
  })) : new Array(10).fill(null).map((_, index) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: index
  }, /*#__PURE__*/React.createElement(_Divider, {
    sx: {
      borderColor: '#dde0e7'
    }
  }), /*#__PURE__*/React.createElement(LeaderboardIndividualItem, {
    challengeType: event.challengeTemplate?.type,
    prevItemRank: null
  })))) : /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 3,
    paddingY: 5
  }, /*#__PURE__*/React.createElement("img", {
    height: 64,
    src: emptyStateIllustration
  }), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/React.createElement(_Typography, {
    align: "center",
    fontWeight: 700
  }, t(isMember === false ? 'commons.challenges.leaderboard.empty_state_title_not_member' : 'commons.challenges.leaderboard.empty_state_title_company')), /*#__PURE__*/React.createElement(_Typography, {
    align: "center",
    variant: "body2"
  }, t(isMember === false ? 'commons.challenges.leaderboard.empty_state_description_not_member' : 'commons.challenges.leaderboard.empty_state_description')))), (!isFree || disableLeaderboardRestriction) && leaderboard && count && count > leaderboard.length ? /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    disabled: loading,
    endIcon: loading && /*#__PURE__*/React.createElement(_CircularProgress, {
      color: "inherit",
      size: 16,
      thickness: 4
    }),
    onClick: () => setPage(page + 1),
    size: "small",
    variant: "outlined"
  }, t('commons.actions.see_more'))) : /*#__PURE__*/React.createElement(React.Fragment, null));
}
export default IndividualLeaderboard;